import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './MedHistory.module.css';
import { DBCheckBox, DBRadioButton } from '_components';


class PatientCareCenterNoteSubjectiveSleep extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='sub_med_hist_sleep' name='Sleep' level={2} allowCollapse={true} >
                <div className={styles.radio_row}>
                    <label className={styles.label_col}>Disturbed Sleep:</label>
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDSLEEPDIST'
                        label='Yes'
                        selectedValue={true}
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDSLEEPDIST'
                        label='No'
                        selectedValue={false}
                        className={styles.radio_col}
                    />
                </div>

                <div className={styles.checkbox_row}>
                    <label className={styles.label_col}>Sleeping Position:</label>
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDSLEEPPOSPRONE' label='Prone' className={styles.checkbox_col} />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDSLEEPPOSR' label='R sidelying' className={styles.checkbox_col} />
                </div>

                <div className={styles.checkbox_row}>
                    <span className={styles.label_col} />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDSLEEPPOSSUPINE' label='Supine' className={styles.checkbox_col} />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDSLEEPPOSL' label='L sidelying' className={styles.checkbox_col} />
                </div>

            </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    return {
        noteId: noteId,
        evno: evno,
    };
}

const connectedPatientCareCenterNoteSubjectiveSleep = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveSleep);
export { connectedPatientCareCenterNoteSubjectiveSleep as PatientCareCenterNoteSubjectiveSleep };

